/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 Shopify.AjaxifyCart = (function ($) {
  // Some configuration options.
  // I have separated what you will never need to change from what
  // you might change.
  var _config = {
    // What you might want to change
    addToCartBtnLabel: 'Add to Bag',
    addedToCartBtnLabel: 'Thank you!',
    addingToCartBtnLabel: 'Adding...',
    soldOutBtnLabel: 'Sold Out',
    howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
    cartCountParentSelector: '#CartCount',
    cartCountSelector: '#CartCount span',
    cartTotalSelector: '#cart-price',
    cartDrawerFooter: '.cart-drawer__footer',
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form, and
    // 'nextButton' for next to add to cart button.
    feedbackPosition: 'belowForm',

    // What you will never need to change
    addToCartBtnSelector: '[type="submit"]',
    addToCartFormSelector: '.product-form[action="/cart/add"], .addToCart-form-quickview',
    shopifyAjaxAddURL: '/cart/add.js',
    shopifyAjaxCartURL: '/cart.js',
  };

  if ($('.preorder-notifier').length) {
    _config.addToCartBtnLabel = 'PreOrder';
  }
  // We need some feedback when adding an item to the cart.
  // Here it is.
  var _showFeedback = function (success, html, $addToCartForm) {
    $('.ajaxified-cart-feedback').remove();
    var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
    switch (_config.feedbackPosition) {
      case 'aboveForm':
        $addToCartForm.before(feedback);
        break;
      case 'belowForm':
        $addToCartForm.after(feedback);
        break;
      case 'nextButton':
      default:
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
        break;
    }
    // If you use animate.css
    // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
    $('.ajaxified-cart-feedback').slideDown();
  };

  var _setText = function ($button, label) {
    if ($button.children().length) {
      $button.children().each(function () {
        if ($.trim($(this).text()) !== '') {
          $(this).text(label);
        }
      });
    } else {
      $button.val(label).text(label);
    }
  };

  var _updateCart = function (product_id, qty, price_element, cartCount) {
    jQuery.getJSON('/cart/update.js', 'updates[' + product_id + ']=' + qty);
    setTimeout(function () {
      jQuery.getJSON('/cart.js', function (cart) {
        price_element.html(theme.Currency.formatMoney(cart.total_price, ''));
        $(cartCount).html(cart.item_count);
      });
    }, 300);
  };

  var _initUpdate = function () {
    var price_element = $('.ajaxcart-total-number');
    //$('#CartDrawer .btn-number.add').on('click', function(e){
    $('#CartDrawer').on('click', '.btn-number.add', function (e) {
      var button_id = '#' + $(this).attr('id');
      var el = $(button_id).parent().prev('.ajaxcart-qty-num'),
        qty = el.val();
      qty++;
      $(button_id).prop('disabled', true);
      el.attr('data-value', qty);
      el.attr('value', qty);
      setTimeout(function () {
        $(button_id).prop('disabled', false);
      }, 2000);

      var product_id = $(button_id).parent().prev('.ajaxcart-qty-num').data('id');
      _updateCart(product_id, qty, price_element, _config.cartCountSelector);
    });

    $('#CartDrawer').on('click', '.btn-number.minus', function (e) {
      var button_id = '#' + $(this).attr('id');
      var el = $(button_id).parent().prev('.ajaxcart-qty-num'),
        qty = el.val();
      if (qty > 1) {
        qty--;
        $(button_id).prop('disabled', true);
        el.attr('data-value', qty);
        el.attr('value', qty);
        setTimeout(function () {
          $(button_id).prop('disabled', false);
        }, 2000);

        var product_id = $(button_id).parent().prev('.ajaxcart-qty-num').data('id');
        _updateCart(product_id, qty, price_element, _config.cartCountSelector);
      }
    });
  };

  var _createItemList = function (cart) {
    $('.cart-drawer__content .ajaxcart-row').remove();
    var i = 0,
      k = 1,
      size = cart.items.length,
      imgUrl,
      itemUrl,
      title = '',
      total = 0,
      col,
      variantTitle = '';
    for (i = 0; i < size; i++, k++) {
      properties = '';
      imgUrl = cart.items[i].image;
      itemUrl = cart.items[i].url;
      title = cart.items[i].product_title;
      total = cart.items[i].line_price + total;
      var bfcfm_message = ''; //optional, used as a callout message for the sale.
      var cart_item_price = theme.Currency.formatMoney(cart.items[i].price);
      var cart_item_discounted_price = theme.Currency.formatMoney(cart.items[i].discounted_price);

      if (cart_item_discounted_price != cart_item_price) {
        cart_item_price =
          '<del>' +
          cart_item_price +
          '</del>' +
          '<br />' +
          bfcfm_message +
          ' ' +
          cart_item_discounted_price;
      }

      if (cart.items[i].variant_title == null) {
        variantTitle = '';
      } else {
        variantTitle =
          '<div class="cart__meta-text item-options">' + cart.items[i].variant_title + '</div>';
      }
      $.each(cart.items[i].properties, function (j, val) {
        if (val != '') {
          if (j.indexOf('_Bundle ID') != -1 || j.indexOf('_Custom Product') != -1) {
          } else properties = properties + '<div>' + j + ':' + val + '</div>';
        }
      });
      col =
        '<div class="grid__item one-fifth small--hide text-center"><a href="/cart/change?line=' +
        k +
        '&amp;quantity=0" class="cart__remove">Remove</a></div>' +
        '<div class="grid__item three-fifths narrowscreen--three-quarters text-center">' +
        '<a href="' +
        itemUrl +
        '" class="ajaxcart-product-image"><img class="cart__image" src="' +
        imgUrl +
        '" alt="' +
        title +
        '"></a>' +
        '<div class="ajaxcart-meta text-center">' +
        '<a href="{{ item.url }}" class="ajaxcart-product-name">' +
        title +
        '</a>' +
        variantTitle +
        '<div class="cart__meta-text item-properties">' +
        properties +
        '</div>' +
        '<div class="ajaxcart-subtotal text-center">' +
        cart_item_price +
        '</div>' +
        '<div style="display:none;" class="narrowscreen--show"><a style="margin-top:0;" href="/cart/change?line=' +
        k +
        '&amp;quantity=0" class="cart__remove">Remove</a></div>' +
        '</div></div>' +
        '<div class="grid__item one-fifth text-center narrowscreen-one-quarter">' +
        '<div class="ajaxcart-qty quantity-input-group">' +
        '<input disabled type="number" name="updates[]" data-id="' +
        cart.items[i].id +
        '" data-value="' +
        cart.items[i].quantity +
        '" class="ajaxcart-qty-num qty-input" id="qty-input-' +
        k +
        '" value="' +
        cart.items[i].quantity +
        '" min="0" data-line="1" aria-label="quantity" pattern="[0-9]*">' +
        '<div class="input-group-btn">' +
        '<button type="button" id="ajax-btn-number-add-' +
        i +
        '" class="btn-number ajax-btn-number add inc-qty" aria-label="Increase item quantity by one"><span class="icon-angle-up"></span></button>' +
        '<button type="button" id="ajax-btn-number-minus-' +
        i +
        '" class="btn-number ajax-btn-number minus dec-qty" aria-label="Reduce item quantity by one"><span class="icon-angle-down"></span></button>' +
        '</div>' +
        '</div></div>';

      var $row = $(
        '<div class="ajaxcart-row text-center"><div class="grid grid--no-gutters">' +
          col +
          '</div></div>',
      );
      $('.cart-drawer__content').append($row);
      $('.ajaxcart-total-number').text(theme.Currency.formatMoney(total));
    }
  };

  Shopify.queue = [];

  var _init = function () {
    $('body').on('click', '.product-form .product-form__cart-submit', function (e) {
      e.preventDefault();
      var addForm = $('#' + e.target.id).closest('form');
      var $addToCartForm = $(addForm);
      var $addToCartBtnText = $(addForm).find(_config.addToCartBtnSelector).text();
      var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);

      if ($('#engraving').length || $('#font-list').length) {
        if ($('#engraving').val().trim().length == 0) {
          if (!$('#engraving-instruction').length) {
            $('#font-list').val('');
          }
        } else {
          if (!$('#font-list').val()) {
            $('#font-list').val($('#font-list').next('.trigger.selected').data('class'));
          }
        }
        if ($('#engraving').length) {
          if ($('#engraving').val().trim() == '') {
            $('#engraving').val('');
          }
        }
        if ($('#engraving-instruction').length) {
          if ($('#engraving-instruction').val().trim() == '') {
            $('#engraving-instruction').val('');
          }
        }
        if ($('#engraving').length && $('#engraving-instruction').length) {
          if (
            $('#engraving').val().trim() == '' &&
            $('#engraving-instruction').val().trim() == ''
          ) {
            $('#font-list').val('');
          }
        }
      } else {
        if (!$('#engrave-pendant-font').val()) {
          $('#engraving-instruction').val('');
        }
      }

      _setText($addToCartBtn, _config.addingToCartBtnLabel);
      $addToCartBtn.addClass('disabled').prop('disabled', true);

      if ($('.ring-bracelet-ajax-add-to-cart').length) {
        var additional_product = [];

        if ($('.ring-bracelet-ajax-add-to-cart.padlock').length) {
          $('.custom-swatch-block-dropdown').each(function () {
            var aproduct = [];

            if ($('.engrave-field-on-pendant').is(':visible')) {
              if ($('#engrave-pendant').val().length == 0) {
                if ($('#engraving-instruction').val()) {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      'Engraving Instructions': $('#engraving-instruction').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                } else {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                  };
                }
              } else {
                if ($('#engraving-instruction').val()) {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      Engraving: $('#engrave-pendant').val(),
                      'Engraving Instructions': $('#engraving-instruction').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                } else {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      Engraving: $('#engrave-pendant').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                }
              }
            } else {
              aproduct = {
                id: $(this).find(':selected').data('value'),
                quantity: $('input[name="quantity"]').val(),
              };
            }

            additional_product.push(aproduct);
            Shopify.queue.push(aproduct);
          });
        } else {
          $('.custom-swatch-block-dropdown:visible').each(function () {
            var aproduct = [];

            if ($('.engrave-field-on-pendant').is(':visible')) {
              if ($('#engrave-pendant').val().length == 0) {
                if ($('#engraving-instruction').val()) {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      'Engraving Instructions': $('#engraving-instruction').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                } else {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                  };
                }
              } else {
                if ($('#engraving-instruction').val()) {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      'Engraving Instructions': $('#engraving-instruction').val(),
                      Engraving: $('#engrave-pendant').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                } else {
                  aproduct = {
                    id: $(this).find(':selected').data('value'),
                    quantity: $('input[name="quantity"]').val(),
                    properties: {
                      Engraving: $('#engrave-pendant').val(),
                      Font: $('#engrave-pendant-font').val(),
                    },
                  };
                }
              }
            } else {
              aproduct = {
                id: $(this).find(':selected').data('value'),
                quantity: $('input[name="quantity"]').val(),
              };
            }

            additional_product.push(aproduct);
            Shopify.queue.push(aproduct);
          });
        }

        //console.log( additional_product );
        function moveAlong() {
          if (Shopify.queue.length > 0) {
            var request = Shopify.queue.shift();
            // Add to cart.
            $.ajax({
              url: _config.shopifyAjaxAddURL,
              dataType: 'json',
              type: 'post',
              data: request,
              success: function (itemData) {
                // Re-enable add to cart button.
                //console.log(itemData);
                $addToCartBtn.addClass('inverted');
                _setText($addToCartBtn, _config.addedToCartBtnLabel);
                //_showFeedback('success','<i class="fa fa-check"></i> Added to cart! See your cart on the right hand side.',$addToCartForm);
                window.setTimeout(function () {
                  $addToCartBtn
                    .prop('disabled', false)
                    .removeClass('disabled')
                    .removeClass('inverted');
                  _setText($addToCartBtn, $addToCartBtnText);
                }, _config.howLongTillBtnReturnsToNormal);
                // Update cart count and show cart link.
                $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
                  if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                    var value = $(_config.cartCountSelector).html() || '0';
                    $(_config.cartCountSelector)
                      .html(value.replace(/[0-9]+/, cart.item_count))
                      .removeClass('hidden-count');
                    $(_config.cartCountParentSelector).removeClass('hide');
                    $(_config.cartCharityBoxParent).removeClass('hide');
                  }
                  if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                    if (
                      typeof Currency !== 'undefined' &&
                      typeof Currency.moneyFormats !== 'undefined'
                    ) {
                      var newCurrency = '';
                      if ($('[name="currencies"]').size()) {
                        newCurrency = $('[name="currencies"]').val();
                      } else if ($('#currencies span.selected').size()) {
                        newCurrency = $('#currencies span.selected').attr('data-currency');
                      }
                      if (newCurrency) {
                        $(_config.cartTotalSelector).html(
                          '<span class=money>' +
                            Shopify.formatMoney(
                              Currency.convert(
                                cart.total_price,
                                '{{ shop.currency }}',
                                newCurrency,
                              ),
                              Currency.money_format[newCurrency],
                            ) +
                            '</span>',
                        );
                      } else {
                        $(_config.cartTotalSelector).html(
                          Shopify.formatMoney(cart.total_price, ''),
                        );
                      }
                    } else {
                      $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ''));
                    }
                  }

                  _createItemList(cart);
                  $('body').addClass('drawer--active js-drawer-open no-scroll');
                  $('#CartDrawer').addClass('active');
                  $('#CartDrawer').animate({right: 0});
                  $(_config.cartDrawerFooter).removeClass('hide');
                  moveAlong();
                });
              },
              error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                //console.log(response.slice(0,4));
                if (response.slice(0, 4) === 'All ') {
                  _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                  $addToCartBtn.prop('disabled', false);
                  _setText($addToCartBtn, _config.addToCartBtnLabel);
                } else {
                  _showFeedback(
                    'error',
                    '<i class="fa fa-warning"></i> ' + response,
                    $addToCartForm,
                  );
                  $addToCartBtn.prop('disabled', false).removeClass('disabled');
                  _setText($addToCartBtn, $addToCartBtnText);
                }
              },
            });
            return false;
          }
        }
        moveAlong();
      } else if ($('.pendant-form-custom').length) {
        var additional_product = [];

        if (!$('#pendant-only-var-id:checked').length) {
          if ($('body').hasClass('temp-product-necklaces')) {
            $('.chain-selection .pendant-block.selected:visible').each(function () {
              var chainSelectedID = $(this).data('variant-id');
              var aproduct = [];

              if ($('.engrave-field-on-pendant').is(':visible')) {
                if ($('#engrave-pendant').val().length == 0) {
                  if ($('#engraving-instruction').val()) {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    aproduct = {id: chainSelectedID, quantity: $('input[name="quantity"]').val()};
                  }
                } else {
                  if ($('#engraving-instruction').val()) {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  }
                }
              } else {
                aproduct = {id: chainSelectedID, quantity: $('input[name="quantity"]').val()};
              }

              additional_product.push(aproduct);
              Shopify.queue.push(aproduct);
            });
          } else if ($('body').hasClass('temp-product-chains')) {

            

            if( $('.chains-main-template').length ){
              /* this is for pendant chains, charms */
              $('.chain-selection .pendant-block.selected:visible').each(function () {
                var chainSelectedID = $(
                  '.custom-swatch-block-dropdown[data-product-id="' +
                    $(this).data('product-id') +
                    '"]',
                )
                  .find(':selected')
                  .val();
                var aproduct = [];

                var HasEngrave = 1;

                if( $('.custom-swatch-block-dropdown[data-product-id="'+$(this).data('product-id')+'"] .pendant-engrave-extra-product').length ){

                  var extraEngrave = $('#engrave-pendant-extra-'+$(this).data('product-id')).val();
                  var extraEngraveFont = $('#engrave-pendant-font-extra-'+$(this).data('product-id')).val();
                  var extraEngraveInstruction = $('#engraving-instruction-extra-'+$(this).data('product-id')).val();

                  if( extraEngrave || extraEngraveInstruction ){
                    if( extraEngrave && !extraEngraveInstruction ){
                      aproduct = {
                        id: chainSelectedID,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          Engraving: extraEngrave,
                          Font: extraEngraveFont
                        }
                      };
                    } else if( !extraEngrave && extraEngraveInstruction ){
                      aproduct = {
                        id: chainSelectedID,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          'Engraving Instructions': extraEngraveInstruction,
                          Font: extraEngraveFont
                        }
                      };
                    } else {
                      aproduct = {
                        id: chainSelectedID,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          'Engraving Instructions': extraEngraveInstruction,
                          Engraving: extraEngrave,
                          Font: extraEngraveFont
                        }
                      };
                    }
                  } else{
                    HasEngrave = 2;
                  }
                } else {
                  HasEngrave = 2;
                }
                if( HasEngrave == 2 ){
                  aproduct = {id: chainSelectedID, quantity: $('input[name="quantity"]').val()};
                }              
                additional_product.push(aproduct);
                Shopify.queue.push(aproduct);
              });
            } else {

              $('.chain-selection .pendant-block.selected:visible').each(function () {
                var chainSelectedID = $(this).data('variant-id');
                var aproduct = [];
                if ($('#engrave-pendant').val().length == 0) {
                  if ($('#engraving-instruction').val()) {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    aproduct = {id: chainSelectedID, quantity: $('input[name="quantity"]').val()};
                  }
                } else {
                  if ($('#engraving-instruction').val()) {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  }
                }
                additional_product.push(aproduct);
                Shopify.queue.push(aproduct);
              });
            }
          } else {
            /* this is for pendant chains, charms */
            $('.chain-selection .pendant-block.selected:visible').each(function () {
              var chainSelectedID = $(
                '.custom-swatch-block-dropdown[data-product-id="' +
                  $(this).data('product-id') +
                  '"]',
              )
                .find(':selected')
                .val();
              var aproduct = [];

              var HasEngrave = 1;

              if( $('.custom-swatch-block-dropdown[data-product-id="'+$(this).data('product-id')+'"] .pendant-engrave-extra-product').length ){

                var extraEngrave = $('#engrave-pendant-extra-'+$(this).data('product-id')).val();
                var extraEngraveFont = $('#engrave-pendant-font-extra-'+$(this).data('product-id')).val();
                var extraEngraveInstruction = $('#engraving-instruction-extra-'+$(this).data('product-id')).val();

                if( extraEngrave || extraEngraveInstruction ){
                  if( extraEngrave && !extraEngraveInstruction ){
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        Engraving: extraEngrave,
                        Font: extraEngraveFont
                      }
                    };
                  } else if( !extraEngrave && extraEngraveInstruction ){
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': extraEngraveInstruction,
                        Font: extraEngraveFont
                      }
                    };
                  } else {
                    aproduct = {
                      id: chainSelectedID,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': extraEngraveInstruction,
                        Engraving: extraEngrave,
                        Font: extraEngraveFont
                      }
                    };
                  }
                } else{
                  HasEngrave = 2;
                }
              } else {
                HasEngrave = 2;
              }
              if( HasEngrave == 2 ){
                aproduct = {id: chainSelectedID, quantity: $('input[name="quantity"]').val()};
              }             
              additional_product.push(aproduct);
              Shopify.queue.push(aproduct);
            });
          }

          if ($('body.temp-product-lariat').length && !additional_product.length) {
            var aproduct = [];

            var seletected_dropdown = $('.swatch-chains .material-chains.selected').data(
              'cart-variant-id',
            );

            if ($('#engrave-pendant').val().length == 0) {
              if ($('#engraving-instruction').val()) {
                aproduct = {
                  id: seletected_dropdown,
                  quantity: $('input[name="quantity"]').val(),
                  properties: {
                    'Engraving Instructions': $('#engraving-instruction').val(),
                    Font: $('#engrave-pendant-font').val(),
                  },
                };
              } else {
                aproduct = {id: seletected_dropdown, quantity: $('input[name="quantity"]').val()};
              }
            } else {
              if ($('#engraving-instruction').val()) {
                aproduct = {
                  id: seletected_dropdown,
                  quantity: $('input[name="quantity"]').val(),
                  properties: {
                    'Engraving Instructions': $('#engraving-instruction').val(),
                    Engraving: $('#engrave-pendant').val(),
                    Font: $('#engrave-pendant-font').val(),
                  },
                };
              } else {
                aproduct = {
                  id: seletected_dropdown,
                  quantity: $('input[name="quantity"]').val(),
                  properties: {
                    Engraving: $('#engrave-pendant').val(),
                    Font: $('#engrave-pendant-font').val(),
                  },
                };
              }
            }

            additional_product.push(aproduct);
            Shopify.queue.push(aproduct);
          }
        }

        if ($('.huggies-template')) {
          additional_product = [];
          var aproduct = [];
          $('#selector-additional_section_2 .js-toggle-qty-box').each(function () {
            var seletected_dropdown = $(this).find('input.product-custom__charm__checkbox');
            if (seletected_dropdown.is(':checked')) {
              if (seletected_dropdown.val()) {
                aproduct = {
                  id: seletected_dropdown.val(),
                  quantity: seletected_dropdown.data('quantity'),
                };
                additional_product.push(aproduct);
                Shopify.queue.push(aproduct);
              }
            }
          });
        }

        var main_product = [];

        if (
          $('body').hasClass('temp-product-chains') ||
          $('body').hasClass('temp-product-necklaces')
        ) {
          if ($('.huggies-template').length) {
            var SelectedMaterial = $('.custom-swatch-block-dropdown.selected');
          } else {
            var SelectedMaterial = $('.custom-swatch-block-dropdown:visible:first');
          }

          main_product = {
            id: SelectedMaterial.find(':selected').val(),
            quantity: $('input[name="quantity"]').val(),
          };

          if( $('.has-pair-product').length ){
            var check_if_single_or_pair = $('select.has-pair-product:first option:selected').text();
            if( check_if_single_or_pair == 'Pair'){
              main_product = {
                id: SelectedMaterial.find(':selected').val(),
                quantity: 2
              };
            } else {
              main_product = {
                id: SelectedMaterial.find(':selected').val(),
                quantity: 1
              };
            }
          }
          if ($('.material-selection .pendant-block.selected').length) {
            additional_product.push(main_product);
            Shopify.queue.push(main_product);
          }
        } else {

          if ($('.spacer-template').length) {
            var SelectedMaterial = $('#xSingleOptionSelector-' + $('.material-selection .material-pendants.selected').data('product-id') ).val();
          } else {
            var SelectedMaterial = $('.material-selection .material-pendants.selected').data('variant-id');
          }

          //console.log(SelectedMaterial);

          if( $('.product-collection-bundle.selected').length ){
            // add each product-bundle-as-material            
            $('.product-collection-bundle.selected').each( function(){
              let productHasEngrave = false;
              if( $(this).data('has-engrave') == true ){
                productHasEngrave = true;
              }

              SelectedMaterial = $(this).data('variant-id');
              if ($('.material-selection .material-pendants.selected').length) {
                // if engrave is visible
                if ($('.engrave-field-on-pendant').is(':visible')) {
                  // check if pendant has no value but the instruction has value
                  if ($('#engrave-pendant').val().length == 0) {
                    if ($('#engraving-instruction').val() && productHasEngrave) {
                      
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          'Engraving Instructions': $('#engraving-instruction').val(),
                          Font: $('#engrave-pendant-font').val(),
                        },
                      };
                    } else {
                      console.log('1 catch on the loop');
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                      };
                    }
                  }
                  // check if instruction has no value but the pendant has value
                  else if ($('#engraving-instruction').val().length == 0) {
                    if ($('#engrave-pendant').val() && productHasEngrave) {
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          Engraving: $('#engrave-pendant').val(),
                          Font: $('#engrave-pendant-font').val(),
                        },
                      };
                    } else {
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                      };
                    }
                  }
                  // catch on the loop
                  else {
                    // if both fields have values
                    if (
                      $('#engraving-instruction').val().length != 0 &&
                      $('#engraving-instruction').val().length != 0 &&
                      productHasEngrave
                    ) {
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                        properties: {
                          'Engraving Instructions': $('#engraving-instruction').val(),
                          Engraving: $('#engrave-pendant').val(),
                          Font: $('#engrave-pendant-font').val(),
                        },
                      };
                    } else {
                      main_product = {
                        id: SelectedMaterial,
                        quantity: $('input[name="quantity"]').val(),
                      };
                    }
                  }
                }
                // no engrave visibile
                else {
                  main_product = {
                    id: SelectedMaterial,
                    quantity: $('input[name="quantity"]').val(),
                  };
                }
                additional_product.push(main_product);
                Shopify.queue.push(main_product);
              }
            });
          } else {
            
            if ($('.material-selection .material-pendants.selected').length) {
              // if engrave is visible
              if ($('.engrave-field-on-pendant').is(':visible')) {
                // check if pendant has no value but the instruction has value
                if ($('#engrave-pendant').val().length == 0) {
                  if ($('#engraving-instruction').val()) {
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    console.log('1 catch on the loop');
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                    };
                  }
                }
                // check if instruction has no value but the pendant has value
                else if ($('#engraving-instruction').val().length == 0) {
                  if ($('#engrave-pendant').val()) {
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                    };
                  }
                }
                // catch on the loop
                else {
                  // if both fields have values
                  if (
                    $('#engraving-instruction').val().length != 0 &&
                    $('#engraving-instruction').val().length != 0
                  ) {
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                      properties: {
                        'Engraving Instructions': $('#engraving-instruction').val(),
                        Engraving: $('#engrave-pendant').val(),
                        Font: $('#engrave-pendant-font').val(),
                      },
                    };
                  } else {
                    main_product = {
                      id: SelectedMaterial,
                      quantity: $('input[name="quantity"]').val(),
                    };
                  }
                }
              }
              // no engrave visibile
              else {
                main_product = {
                  id: SelectedMaterial,
                  quantity: $('input[name="quantity"]').val(),
                };
              }
              additional_product.push(main_product);
              Shopify.queue.push(main_product);
            }

          }

          if (
            $('.temp-product-lariat .secondary-lariat-lists-swatch .chains-block.selected').length
          ) {
            // console.log('here');
            $(
              '.temp-product-lariat .secondary-lariat-lists-swatch .chains-block.selected:visible',
            ).each(function () {
              var thisCharm = $(this);
              main_product = {
                id: thisCharm.data('variant-id'),
                quantity: $('input[name="quantity"]').val(),
              };

              additional_product.push(main_product);
              Shopify.queue.push(main_product);
            });
          }
        }
        console.log(additional_product);

        //return;

        function moveAlong() {
          if (Shopify.queue.length > 0) {
            var request = Shopify.queue.shift();
            // Add to cart.
            $.ajax({
              url: _config.shopifyAjaxAddURL,
              dataType: 'json',
              type: 'post',
              data: request,
              success: function (itemData) {
                // Re-enable add to cart button.
                //console.log(itemData);
                $addToCartBtn.addClass('inverted');
                _setText($addToCartBtn, _config.addedToCartBtnLabel);
                //_showFeedback('success','<i class="fa fa-check"></i> Added to cart! See your cart on the right hand side.',$addToCartForm);
                window.setTimeout(function () {
                  $addToCartBtn
                    .prop('disabled', false)
                    .removeClass('disabled')
                    .removeClass('inverted');
                  _setText($addToCartBtn, $addToCartBtnText);
                }, _config.howLongTillBtnReturnsToNormal);
                // Update cart count and show cart link.
                $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
                  if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                    var value = $(_config.cartCountSelector).html() || '0';
                    $(_config.cartCountSelector)
                      .html(value.replace(/[0-9]+/, cart.item_count))
                      .removeClass('hidden-count');
                    $(_config.cartCountParentSelector).removeClass('hide');
                    $(_config.cartCharityBoxParent).removeClass('hide');
                  }
                  if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                    if (
                      typeof Currency !== 'undefined' &&
                      typeof Currency.moneyFormats !== 'undefined'
                    ) {
                      var newCurrency = '';
                      if ($('[name="currencies"]').size()) {
                        newCurrency = $('[name="currencies"]').val();
                      } else if ($('#currencies span.selected').size()) {
                        newCurrency = $('#currencies span.selected').attr('data-currency');
                      }
                      if (newCurrency) {
                        $(_config.cartTotalSelector).html(
                          '<span class=money>' +
                            Shopify.formatMoney(
                              Currency.convert(
                                cart.total_price,
                                '{{ shop.currency }}',
                                newCurrency,
                              ),
                              Currency.money_format[newCurrency],
                            ) +
                            '</span>',
                        );
                      } else {
                        $(_config.cartTotalSelector).html(
                          Shopify.formatMoney(cart.total_price, ''),
                        );
                      }
                    } else {
                      $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ''));
                    }
                  }

                  _createItemList(cart);
                  $('body').addClass('drawer--active js-drawer-open no-scroll');
                  $('#CartDrawer').addClass('active');
                  $('#CartDrawer').animate({right: 0});
                  $(_config.cartDrawerFooter).removeClass('hide');
                  moveAlong();
                });
              },
              error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                //console.log(response.slice(0,4));
                if (response.slice(0, 4) === 'All ') {
                  _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                  $addToCartBtn.prop('disabled', false);
                  _setText($addToCartBtn, _config.addToCartBtnLabel);
                } else {
                  _showFeedback(
                    'error',
                    '<i class="fa fa-warning"></i> ' + response,
                    $addToCartForm,
                  );
                  $addToCartBtn.prop('disabled', false).removeClass('disabled');
                  _setText($addToCartBtn, $addToCartBtnText);
                }
              },
            });
            return false;
          }
        }
        moveAlong();
      } else {
        // Add to cart.
        $.ajax({
          url: _config.shopifyAjaxAddURL,
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          success: function (itemData) {
            console.log(itemData);
            console.log('AJAX SINGLE');
            // Re-enable add to cart button.
            $addToCartBtn.addClass('inverted');
            _setText($addToCartBtn, _config.addedToCartBtnLabel);
            //_showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$addToCartForm);
            window.setTimeout(function () {
              $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              _setText($addToCartBtn, _config.addToCartBtnLabel);
            }, _config.howLongTillBtnReturnsToNormal);
            // Update cart count and show cart link.
            $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
              if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                var value = $(_config.cartCountSelector).html() || '0';
                $(_config.cartCountSelector)
                  .html(value.replace(/[0-9]+/, cart.item_count))
                  .removeClass('hidden-count');
              }
              if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                if (
                  typeof Currency !== 'undefined' &&
                  typeof Currency.moneyFormats !== 'undefined'
                ) {
                  var newCurrency = '';
                  if ($('[name="currencies"]').size()) {
                    newCurrency = $('[name="currencies"]').val();
                  } else if ($('#currencies span.selected').size()) {
                    newCurrency = $('#currencies span.selected').attr('data-currency');
                  }
                  if (newCurrency) {
                    $(_config.cartTotalSelector).html(
                      '<span class=money>' +
                        Shopify.formatMoney(
                          Currency.convert(cart.total_price, '{{ shop.currency }}', newCurrency),
                          Currency.money_format[newCurrency],
                        ) +
                        '</span>',
                    );
                  } else {
                    $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ''));
                  }
                } else {
                  $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ''));
                }
              }

              _createItemList(cart);
              $('body').addClass('drawer--active js-drawer-open no-scroll');
              $('#CartDrawer').addClass('active');
              $('#CartDrawer').animate({right: 0});
              $(_config.cartDrawerFooter).removeClass('hide');
              //_initUpdate();
            });
          },
          error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            if (response.slice(0, 4) === 'All ') {
              _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
              $addToCartBtn.prop('disabled', false);
              _setText($addToCartBtn, _config.soldOutBtnLabel);
              $addToCartBtn.prop('disabled', true);
            } else {
              _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
              $addToCartBtn.prop('disabled', false).removeClass('disabled');
              _setText($addToCartBtn, _config.addToCartBtnLabel);
            }
          },
        });
      }
      return false;
    });
  };
  return {
    init: function (params) {
      // Configuration
      params = params || {};
      // Merging with defaults.
      $.extend(_config, params);
      // Action
      $(function () {
        _init();
        _initUpdate();
      });
    },
    getConfig: function () {
      return _config;
    },
  };
})(jQuery);
Shopify.AjaxifyCart.init();
